<app-intro title="Acheter ou louer"></app-intro>
<div class="bg-grey py-5">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center-bottom">
      <div>
        <h2 class="text-purple">{{ titre }}</h2>
        <p *ngIf="bien.transaction === 'vente'" class="text-yellow">
          {{ bien.prix + bien.fraisNego + bien.fraisActe }} €
          <span class="hni">HNI</span>
        </p>
        <p *ngIf="bien.transaction === 'location'" class="text-yellow">
          {{ bien.meuble ? bien.prix / 2 : bien.prix }} €
        </p>
        <div class="my-3 text-center text-lg-start">
          <ul>
            <li>Réf: {{ bien.reference }}</li>
            <li>{{ bien.nbPieces }} pièces</li>
            <li>{{ bien.surfaceHabitable }}m2</li>
          </ul>
        </div>
      </div>
      <div>
        <a href="offres" class="btn btn-yellow">
          <i class="fa-solid fa-arrow-left text-white"></i>
          RETOUR
        </a>
      </div>
    </div>

    <div class="row text-center text-lg-start">
      <div class="col-lg-6">
        <div class="carousel-container">
          <div
            id="carouselExampleControls"
            class="carousel slide"
            data-bs-ride="carousel"
            (slid.bs.carousel)="onSlideChanged($event)"
          >
            <div class="carousel-indicators" *ngIf="images?.length > 1">
              <button
                *ngFor="let img of images; let i = index;"
                type="button"
                data-bs-target="#carouselExampleControls"
                [attr.aria-label]="'Slide ' + (i + 1)"
                [attr.data-bs-slide-to]="i"
                [ngClass]="{ active: currentSlide === i }"
              ></button>
            </div>
            <div class="carousel-inner" *ngIf="arrayLength !== 0">
              <div
                class="carousel-item"
                *ngFor="let img of images; let i = index;"
                [ngClass]="{ active: i === 0 }"
              >
                <img src="{{ img.file }}" class="d-block w-100" />
              </div>
            </div>
            <div *ngIf="arrayLength == 0">
              <div style="width: 500px !important; margin: auto">
                <img src="{{ bien.images[0]?.file }}" class="d-block w-100" />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <!-- <img class="img-fluid" src="{{bien.images[0]?.file}}"> -->
        <div class="row d-flex px-3 mb-3 my-4">
          <div class="col-lg-4 ps-0">
            <div class="d-flex align-items-center border-end">
              <i class="fa-regular fa-circle-user fa-2x text-purple"></i>
              <div class="ms-3">
                <p class="m-0 text-purple">{{ bien.negociateur }}</p>
                <!-- <p class="m-0">Negociateur</p> -->
              </div>
            </div>
          </div>
          <div class="col-lg-8 mt-3 mt-lg-0">
            <p class="m-0">{{ bien.phone }}</p>
            <p class="m-0">{{ bien.mail }}</p>
          </div>
        </div>
        <div>
          <p class="mb-3">Descriptif du bien immobilier</p>
          <p>{{ bien.annonce }}</p>
        </div>
        <div class="my-3" *ngIf="bien.annonceAnglais">
          <p>{{ bien.annonceAnglais }}</p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="bg-white p-4">
          <p *ngIf="bien.transaction === 'vente'">
            Dont prix de vente: {{ bien.prix }} € HNI
          </p>
          <p *ngIf="bien.transaction === 'location'">
            Loyer mensuel: {{ bien.meuble ? bien.prix / 2 : bien.prix }} €
          </p>
          <p *ngIf="bien.transaction === 'vente'">
            Dont EN* TTC à la charge de l'acquéreur:
            {{ bien.fraisNego + bien.fraisActe }} €
          </p>
          <p *ngIf="bien.transaction === 'location'">
            Frais de bail: {{ bien.fraisNego + bien.fraisActe }} €
          </p>
          <div class="mt-3" *ngIf="bien.surfaceHabitable">
            <p>
              <i class="fa-solid fa-table-cells-large"></i> Surface habitable en m²
              <br /><strong>{{ bien.surfaceHabitable }}m²</strong>
            </p>
          </div>
          <div class="my-3" *ngIf="bien.surfaceSejour">
            <p>
              <i class="fa-solid fa-table-cells-large"></i> Surface séjour en m²
              <br /><strong>{{ bien.surfaceSejour }}m²</strong>
            </p>
          </div>
          <div class="my-3" *ngIf="bien.surfaceTerrain">
            <p>
              <i class="fa-solid fa-tree"></i> Surface terrain <br /><strong>{{
                bien.surfaceTerrain
              }}</strong>
            </p>
          </div>
          <div class="my-3" *ngIf="bien.nbPieces">
            <p>
              <i class="fa-sharp fa-solid fa-table-cells-large"></i> Nombre de
              pièces <br /><strong>{{ bien.nbPieces }}</strong>
            </p>
          </div>
          <div class="my-3" *ngIf="bien.nbChambres">
            <p>
              <i class="fa-solid fa-bed"></i> Nombre de chambres
              <br /><strong>{{ bien.nbChambres }}</strong>
            </p>
          </div>
          <div class="my-3">
            <p>Autres Informations</p>

            <div class="my-3" *ngIf="bien.dateAssainissement">
              <i class="fa-solid fa-calendar"></i>
              Date d'assainissement <br />
              <strong>{{ bien.dateAssainissement }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.etat">
              <i class="fa-solid fa-info"></i>
              État <br />
              <strong>{{ bien.etat }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.adresse">
              <i class="fa-solid fa-location-dot"></i>
              Adresse <br />
              <strong>{{ bien.adresse }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.coproprieteNomination">
              <i class="fa-solid fa-building"></i>
              Copropriété <br />
              <strong>{{ bien.coproprieteNomination }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.photo360url">
              <i class="fa-solid fa-camera"></i>
              Photo 360 <br />
              <strong
                ><a [href]="bien.photo360url" target="_blank">Voir</a></strong
              >
            </div>

            <div class="my-3" *ngIf="bien.typeAssainissement">
              <i class="fa-solid fa-water"></i>
              Type d'assainissement <br />
              <strong>{{ bien.typeAssainissement }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.assainissement">
              <i class="fa-solid fa-droplet"></i>
              Assainissement <br />
              <strong>{{ bien.assainissement }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.quartier">
              <i class="fa-solid fa-map"></i>
              Quartier <br />
              <strong>{{ bien.quartier }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.commentaire_Prix">
              <i class="fa-solid fa-comment-dollar"></i>
              Commentaire prix <br />
              <strong>{{ bien.commentaire_Prix }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.dateSeance">
              <i class="fa-solid fa-calendar-check"></i>
              Date séance <br />
              <strong>{{ bien.dateSeance }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.nbreTete">
              <i class="fa-solid fa-users"></i>
              Nombre de têtes <br />
              <strong>{{ bien.nbreTete }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.prixRente">
              <i class="fa-solid fa-dollar-sign"></i>
              Prix rente <br />
              <strong>{{ bien.prixRente }}</strong>
            </div>

            <div class="my-3" *ngIf="bien.libelleSousNature">
              <i class="fa-solid fa-tag"></i>
              Libellé sous nature <br />
              <strong>{{ bien.libelleSousNature }}</strong>
            </div>
          </div>

          <div>
            <!-- <img class="img-fluid" src="assets/toRemove/dpe.jpg"> -->
            <app-dpe-ges
              [dpeDate]="bien.dpeDate"
              [dpeValue]="bien.dpenrj"
              [dpeLettre]="bien.dpeLettre"
              [gesValue]="bien.dpeges"
              [gesLettre]="bien.gesLettre"
            ></app-dpe-ges>
          </div>
        </div>
      </div>
    </div>

    <app-contact-shortcut></app-contact-shortcut>
  </div>
</div>
